class TpProductStories extends HTMLElement {
  connectedCallback() {
    if (this.dataset.tpBound === 'true') return;
    this.dataset.tpBound = 'true';

    this.bubbles = Array.from(this.querySelectorAll('.tp-stories__bubble'));
    this.slots = Array.from(this.querySelectorAll('.tp-stories__thumb'));
    this.videos = this.slots.map((slot) => slot.querySelector('video'));
    this.viewer = this.querySelector('.tp-stories__viewer');
    this.segments = Array.from(this.viewer.querySelectorAll('.tp-stories__segment-fill'));
    this.stage = this.viewer.querySelector('.tp-stories__stage');
    this.viewerTitle = this.viewer.querySelector('.tp-stories__viewer-title');

    this.current = -1;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.onKeydown = this.onKeydown.bind(this);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.onEnded = this.onEnded.bind(this);

    this.bubbles.forEach((bubble, index) => {
      bubble.addEventListener('click', () => this.open(index));
    });

    this.viewer.querySelector('.tp-stories__close').addEventListener('click', () => this.close());

    this.viewer.addEventListener('click', (event) => {
      if (event.target === this.viewer) this.close();
    });

    this.prevButton = this.viewer.querySelector('.tp-stories__nav--prev');
    this.nextButton = this.viewer.querySelector('.tp-stories__nav--next');

    this.prevButton.addEventListener('click', () => this.show(this.current - 1));
    this.nextButton.addEventListener('click', () => this.show(this.current + 1));

    this.stage.addEventListener('pointerdown', (event) => {
      this.pointerStart = { x: event.clientX, y: event.clientY };
    });

    this.stage.addEventListener('pointerup', (event) => {
      if (!this.pointerStart) return;
      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.pointerStart = null;

      if (Math.abs(deltaY) > 80 && Math.abs(deltaY) > Math.abs(deltaX)) {
        this.close();
      } else if (Math.abs(deltaX) > 60) {
        this.show(deltaX < 0 ? this.current + 1 : this.current - 1);
      }
    });

    this.watchPreviews();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('keydown', this.onKeydown);
    document.documentElement.classList.remove('tp-stories-lock');

    if (this.viewer && this.viewer.parentNode === document.body) {
      this.release();
      this.viewer.hidden = true;
      this.appendChild(this.viewer);
    }
  }

  watchPreviews() {
    if (this.reducedMotion || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (this.viewer.hidden === false) return;
          this.videos.forEach((video) => {
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      },
      { rootMargin: '100px' }
    );

    this.observer.observe(this);
  }

  open(index) {
    if (this.viewer.parentNode !== document.body) document.body.appendChild(this.viewer);

    this.viewer.hidden = false;
    document.documentElement.classList.add('tp-stories-lock');
    document.addEventListener('keydown', this.onKeydown);
    this.show(index);
  }

  close() {
    this.release();
    this.viewer.hidden = true;
    this.current = -1;
    this.prevButton.disabled = false;
    document.documentElement.classList.remove('tp-stories-lock');
    document.removeEventListener('keydown', this.onKeydown);
    this.segments.forEach((segment) => {
      segment.style.width = '0%';
    });

    if (!this.reducedMotion) {
      this.videos.forEach((video) => video && video.play().catch(() => {}));
    }
  }

  release() {
    const video = this.videos[this.current];
    if (!video) return;

    video.pause();
    video.removeEventListener('timeupdate', this.onTimeUpdate);
    video.removeEventListener('ended', this.onEnded);
    video.classList.remove('tp-stories__video--playing');
    video.loop = true;
    video.muted = true;
    video.controls = false;
    this.slots[this.current].appendChild(video);
  }

  show(index) {
    if (index < 0) return;
    if (index >= this.bubbles.length) {
      this.close();
      return;
    }

    this.release();
    this.current = index;
    this.prevButton.disabled = index === 0;

    const video = this.videos[index];
    const label = this.bubbles[index].getAttribute('aria-label');
    this.viewerTitle.textContent = label === 'Story' ? '' : label;

    this.segments.forEach((segment, position) => {
      segment.style.width = position < index ? '100%' : '0%';
    });

    if (!video) return;

    video.loop = false;
    video.muted = false;
    video.controls = false;
    video.classList.add('tp-stories__video--playing');
    video.currentTime = 0;
    video.addEventListener('timeupdate', this.onTimeUpdate);
    video.addEventListener('ended', this.onEnded);
    this.stage.appendChild(video);

    video.play().catch(() => {
      video.muted = true;
      video.play().catch(() => {});
    });
  }

  onTimeUpdate(event) {
    const video = event.target;
    const segment = this.segments[this.current];
    if (!segment || !video.duration) return;
    segment.style.width = `${(video.currentTime / video.duration) * 100}%`;
  }

  onEnded() {
    this.show(this.current + 1);
  }

  onKeydown(event) {
    if (this.viewer.hidden) return;

    if (event.key === 'Escape') this.close();
    if (event.key === 'ArrowRight') this.show(this.current + 1);
    if (event.key === 'ArrowLeft') this.show(this.current - 1);
  }
}

if (!customElements.get('tp-product-stories')) {
  customElements.define('tp-product-stories', TpProductStories);
}
